module.exports = __webpack_public_path__ + "static/cloud_night-8ad5335d0d29d4cf37debc3c5dde3640.jpg";